import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ReadJob, VerifySnippetRequest } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type VerifyOrganizationSnippetParams = {
  organizationId: string;
  data: VerifySnippetRequest;
};

export const verifyOrganizationSnippet = async (
  params: VerifyOrganizationSnippetParams,
): Promise<ReadJob> => {
  return await tinctApi.organizations.verifyOrganizationSnippet(
    params.organizationId,
    params.data,
  );
};

export const useVerifyOrganizationSnippet = (
  options?: Omit<
    UseMutationOptions<ReadJob, ApiError, VerifyOrganizationSnippetParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: verifyOrganizationSnippet,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['organization', args[1].organizationId],
      });
      queryClient.invalidateQueries({
        queryKey: ['snippet-verification-result', args[1].organizationId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
